import { Component, Input, OnInit } from '@angular/core';

import * as _ from 'lodash-es';

import { ProjectService } from '../../../services/project.service';
import { SearchService } from '../../../services/core.search.service';
import { GfTranslateService } from '../../../services/core.translate.service';
import { StateService } from '@uirouter/angular';
import { GfTitleService } from '../../../services/core.title.service';
import { OrgHelper } from '../services/admin.org-helper.service';
import { UiService } from '../../../services/core.ui.service';
@Component({
    selector: 'siteAdminOrgs',
    template: require('./admin.orgs.component.html')
})
export class SiteAdminOrgsView implements OnInit {

    protected filters: any = {};
    private orgs: any;
    protected rootOrgs: any;

    protected project: any;
    private breadcrumbs: any;

    protected parent: any;
    protected children: any;
    protected memberCount: number = null;

    protected childSearch: any = { text: '' };
    protected parentSearch: any = { text: '' };

    protected childOpts: any = [];
    protected parentOpts: any = [];
    protected searchingChildren = false;
    protected searchingParents = false;

    private targetParent;
    private targetChild;
    protected targetType;
    protected targetName;

    private rootNodes = [];
    protected rootOptions: any = {
        displayField: 'name',
        idField: 'id',
        childrenField: 'children',
        getChildren: (item: any) => {
            return this.projectService.fetch({ parentProjectId: item.id, rel: 'childCount', page_size: 100 })
            .then((data: any) => {
                this.orgs = this.orgHelper.addProjectsToTree(this.orgs, data.items);
                this.rootOrgs = this.orgHelper.getRootElements(this.orgs);
            });
        },
        onSelectItem: null
    };

    constructor(

        private projectService: ProjectService,
        private searchService: SearchService,
        public stateService: StateService,
        private gfTranslateService: GfTranslateService,
        private uiService: UiService,
        protected orgHelper: OrgHelper,
        private $window: Window,
        private titleService: GfTitleService,
    ) { }
    
    ngOnInit() {
        // Always set up the filters from $stateParams
        // $stateParams is the authoritative source,
        // and when anything gets changed, we use this.stateService.go,
        // then re-read $stateParams.
        this.filters = this.orgHelper.setFilterValues(
            this.orgHelper.createOrgFilters(), 
            this.stateService.params
        );
        this.getOrgs();
        this.rootOptions.onSelectItem = this.selectProject;
        this.titleService.setTitle('Site Admin', 'Orgs');
    }

    /** EVENT HANDLERS FROM HTML **/
    private selectProject = (project) => {
        this.stateService.go('.', { selectedProject: project.unixName })
            .then(() => { this.getSelectedProject(project.unixName); }, () => {});
    };

    /** EVENT HANDLERS FROM HTML **/


    /** DISPLAY FUNCTIONS **/
    // Left these two functions  in the controller because they're so simple.
    // If we need them for another view, we can refactor later.
    private isPending = function() {
        return _.get(this.project, 'status', 0) == 0;
    };

    private isActive = function() {
        return _.get(this.project, 'status', 0) == 1;
    };
    /** DISPLAY FUNCTIONS **/

    getOrgs() {

        // Always reset the state for detail view
        this.project = null;
        this.parent = null;
        this.children = null;

        var params: any = _.merge(
            { parentProjectId: 0, rel: 'childCount', page_size: 100, isOrg: 1 },
            this.applyFilters(this.filters)
        );

        // There's a mismatch between the filter widget and the API
        // as to what constitutes "empty" for the text search.
        // Filter needs "", but the API needs null, so we carry ""
        // in the this.filters param, but remove it before API calls.
        if (params.text == '') delete params.text;

        this.orgs = false;
        this.rootOrgs = false;

        this.projectService.fetch(params)
            .then((data: any) => {
                this.orgs = this.orgHelper.addProjectsToTree([], data.items);
                this.rootOrgs = this.orgHelper.getRootElements(this.orgs);
                const proj = _.get(this.stateService.params, 'selectedProject', false);
                if (proj) {
                    this.getSelectedProject(proj);
                } else {
                    this.breadcrumbs = this.orgHelper.getOrgBreadcrumbs(null);
                }
            });
    }
    /** INITIAL DATA FETCH **/

    /** FILTER EVENTS **/
    protected onApplyFilters = this.getOrgs;

    onResetFilters() {
        this.filters = this.orgHelper.createOrgFilters();
        this.applyFilters(this.filters, {});
    };

    applyFilters(filters, sort: any = {}) {
        var _params = this.orgHelper.getFilterValues(filters);
        // Always un-select project when applying filters
        _params['selectedProject'] = null;
        _params['page_num'] = 1;
        _params['sort_field'] = _.get(sort, 'field', 'id');
        _params['sort_dir'] = _.get(sort, 'dir', 'asc');

        this.stateService.go('.', _params, { notify: true });
        return _params;
    };
    /** FILTER EVENTS **/


    /** PROJECT DETAIL / SELECTION **/
    getSelectedProject(unixName) {

        if (!unixName) {
            this.project = null;
            this.orgs = null;
            this.breadcrumbs = this.orgHelper.getOrgBreadcrumbs(this.project);
            return this.getOrgs();
        }

        var target = _.find(this.orgs, { unixName: unixName });

        if (target) {
            return this.setCurrentProject(target);
        }

        this.projectService.getParents(unixName, { rel: 'childCount' })
            .then((data: any) => {
                this.orgs = this.orgHelper.addProjectsToTree(this.orgs, data.items);
                this.rootOrgs = this.orgHelper.getRootElements(this.orgs);
                var target = _.find(this.orgs, { unixName: unixName });
                if (target) {
                    this.setCurrentProject(target);
                } else {
                    this.uiService.message.showWarning(
                        this.gfTranslateService.translate('Selected project is not visible in the project tree')
                    );
                }
            });
    }

    setCurrentProject(project) {

        // var node = project;
        // while (node) {
        //     this.toggleCollapse(node, true);
        //     node = node.parent;
        // }

        this.project = project;
        this.rootOptions.selectedItem = project;
        this.breadcrumbs = this.orgHelper.getOrgBreadcrumbs(project);

        if (project) {
            // Set values for right-side edit panel
            // Yes, these are somewhat redundant to the this.orgs tree,
            // but it's also clearer where the bindings come from, and
            // it won't get crossed up with tree mgmt needs.
            this.parent = project.parent;
            this.children = null;
            this.memberCount = null;

            this.projectService.fetch({ parentProjectId: this.project.id, rel: 'childCount', page_size: 100 })
                .then((data: any) => {
                    this.children = data.items;
                    this.orgs = this.orgHelper.addProjectsToTree(this.orgs, data.items);
                }, (result) => {
                    console.log(result);
                });

            this.projectService.get(project.unixName, '', { rel: 'org_metrics' })
                .then((data: any) => {
                    const metrics = _.get(data, 'rel.org_metrics', false);
                    this.memberCount = metrics ? metrics.users : null;
                }, () => {
                    this.memberCount = null;
                });
        }

        return project;
    }
    /** PROJECT DETAIL / SELECTION **/


    /** PROJECT PARENT/CHILD SEARCH AND SELECTION **/

    doSearchParents = _.debounce(() => {
        if (this.parentSearch.text) {
            this.searchService.searchProjects({ page_size: 99, q: this.parentSearch.text, canParent: this.project.id })
            .then((ret: any) => {
                this.parentOpts = ret.items;
                this.searchingParents = false;
            }, () => {
                this.parentOpts = [];
                this.searchingParents = false;
            });
        }
        else {
            this.parentOpts = [];
            this.searchingParents = false;
        }
    }, 1000);

    doSearchChildren = _.debounce(() => {
        if (this.childSearch.text) {
            this.searchService.searchProjects({ page_size: 99, q: this.childSearch.text, canChild: this.project.id })
            .then((ret: any) => {
                this.childOpts = ret.items;
                this.searchingChildren = false;
            }, () => {
                this.childOpts = [];
                this.searchingChildren = false;
            });
        }
        else {
            this.childOpts = [];
            this.searchingChildren = false;
        }
    }, 1000);

    searchParents = function() {
        this.searchingParents = true;
        this.doSearchParents();
    };

    searchChildren = function() {
        this.searchingChildren = true;
        this.doSearchChildren();
    };

    protected setParent = (parentId, childId, updateType) => {
        if (parentId == 0 || childId == 0) {
            this.targetParent = parentId;
            this.targetChild = childId;
            this.targetType = updateType;
            this.targetName = parentId || childId;
        }
        else {
            this.projectService.setParent(childId, parentId).then(() => {
                this.uiService.message.showSuccess('Updated ' + updateType);
                this.stateService.reload();
            }, (result) => {
                console.log(result);
                var msg = _.get(result, 'message', this.gfTranslateService.translate('An error occurred.'));
                this.uiService.message.showWarning('Failed to update ' + updateType + ': ' + msg);
            });
        }
    };

    protected setParentForce = function() {
        this.projectService.setParent(this.targetChild, this.targetParent)
            .then(() => {
                this.uiService.message.showSuccess('Updated ' + this.targetType);
                this.stateService.reload();
            }, (result) => {
                console.log(result);
                var msg = _.get(result, 'message', this.gfTranslateService.translate('An error occurred.'));
                this.uiService.message.showWarning(this.gfTranslateService.translate('Failed to update ') + this.targetType + ': ' + msg);
            });
    };
    /** PROJECT PARENT/CHILD SEARCH AND SELECTION **/
}